'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var keymap = _interopDefault(require('../keymap/index.js'));
var index_js = require('../utils/index.js');
var index_js$1 = require('../cursor/index.js');
var prosemirrorTransform = require('prosemirror-transform');
require('prosemirror-model');
var prosemirrorState = require('prosemirror-state');

// () -> string

function uuid() {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('');
  const id = [];

  for (let i = 0; i < 8; i++) {
    id.push(chars[parseInt(Math.random() * chars.length, 10)]);
  }

  return id.join('');
}

var schema = {
  nodes: {
    // :: NodeSpec A blockquote (`<blockquote>`) wrapping one or more blocks.
    blockquote: {
      content: 'block+',
      group: 'block',
      defining: true,
      allowGapCursor: true,
      attrs: {
        dataDiffId: {
          default: null
        }
      },
      parseDOM: [{
        tag: 'blockquote',

        getAttrs(dom) {
          const dataDiffId = dom.getAttribute('data-diff-id');
          return {
            dataDiffId
          };
        }

      }],

      toDOM(dom) {
        const {
          attrs: {
            dataDiffId
          }
        } = dom;
        return ['blockquote', {
          class: 'ct-blockquote',
          'data-diff-id': dataDiffId || `ct-diff-id-${uuid()}`
        }, 0];
      }

    }
  }
};

function isInQuote(state) {
  const {
    selection,
    schema
  } = state;
  const node = index_js.findParentNode(selection.$anchor.path, node => node.type === schema.nodes.blockquote);
  return !!node;
}

function wrapInQuote(attrs) {
  return function (state, dispatch, view) {
    const {
      paragraph,
      heading,
      ordered_list,
      bullet_list,
      task_list,
      blockquote
    } = state.schema.nodes;
    const listTypes = [ordered_list, bullet_list, task_list];
    let selection = state.selection; // 引用inline节点（如链接）

    if (!selection.$anchor.parent.type.isBlock) {
      const node = index_js.findParentNode(selection.$anchor.path, n => [paragraph, heading].includes(n.type));
      if (!node) return false;
      selection = prosemirrorState.TextSelection.create(state.doc, node.pos + 1);
    } // 虚拟光标


    if (selection instanceof index_js$1.GapCursor) {
      const {
        $from,
        from,
        dom
      } = selection;
      const nodeAfter = $from.nodeAfter;
      const nodeBefore = $from.nodeBefore;

      if (dom) {
        const {
          tagName,
          className
        } = dom;
        const nodeAfterName = nodeAfter && nodeAfter.type.name.split('_')[0];
        const nodeBeforeName = nodeBefore && nodeBefore.type.name.split('_')[0]; // 判断要引用的内容是在下一行还是上一行

        if (nodeAfterName && (tagName.toLowerCase() === nodeAfterName || className.includes(nodeAfterName))) {
          selection = prosemirrorState.TextSelection.create(state.doc, from, from + nodeAfter.nodeSize);
        } else if (nodeBeforeName && (tagName.toLowerCase() === nodeBeforeName || className.includes(nodeBeforeName))) {
          selection = prosemirrorState.TextSelection.create(state.doc, from - nodeBefore.nodeSize, from);
        }
      }
    }

    const {
      $from,
      $to
    } = selection;
    let range = $from.blockRange($to); // 在序列中引用

    const listNode = index_js.findParentNode($from.path, node => listTypes.includes(node.type));

    if (listNode) {
      const start = listNode.pos;
      const end = listNode.pos + listNode.node.nodeSize - 1;
      selection = prosemirrorState.TextSelection.create(state.doc, start, end);
      range = selection.$from.blockRange(selection.$to);
    }

    const wrapping = range && prosemirrorTransform.findWrapping(range, blockquote, attrs);

    if (!wrapping) {
      return false;
    }

    dispatch(state.tr.wrap(range, wrapping));
    return true;
  };
} // :: (EditorState, ?(tr: Transaction)) → bool


function unwrapInQuote(state, dispatch) {
  const {
    paragraph,
    heading,
    ordered_list,
    bullet_list,
    task_list
  } = state.schema.nodes;
  const listTypes = [ordered_list, bullet_list, task_list];
  let selection = state.selection; // 光标在inline节点中（如链接）

  if (!selection.$anchor.parent.type.isBlock) {
    const node = index_js.findParentNode(selection.$anchor.path, node => [paragraph, heading].includes(node.type));
    if (!node) return false;
    selection = prosemirrorState.TextSelection.create(state.doc, node.pos + 1);
  }

  const $from = selection.$from;
  const $to = selection.$to;
  let range = $from.blockRange($to); // 在序列中引用

  const listNode = index_js.findParentNode($from.path, node => listTypes.includes(node.type));

  if (listNode) {
    const start = listNode.pos;
    const end = listNode.pos + listNode.node.nodeSize - 1;
    selection = prosemirrorState.TextSelection.create(state.doc, start, end);
    range = selection.$from.blockRange(selection.$to);
  }

  const target = range && prosemirrorTransform.liftTarget(range);
  if (target == null) return false;
  dispatch(state.tr.lift(range, target).scrollIntoView());
  return true;
}
function toggle(state) {
  if (isInQuote(state)) {
    return unwrapInQuote;
  }

  return wrapInQuote();
}

function handleBackspace(state, dispatch, view) {
  const {
    tr,
    selection,
    schema
  } = state;
  const {
    $cursor,
    from,
    to
  } = selection;
  const {
    blockquote
  } = schema.nodes; // 光标在行首

  if ($cursor && $cursor.parentOffset === 0) {
    const parentType = $cursor.parent.type;
    const plus = parentType.isInline ? 2 : 1;
    const cursorNodeParent = $cursor.node(-plus);
    const cursorNode = parentType.isInline ? $cursor.node(-1) : $cursor.node();
    if (!cursorNodeParent) return false;
    const nodeAfter = $cursor.nodeAfter; // 光标后相邻节点

    const nodeBefore = $cursor.nodeBefore; // 光标前相邻节点

    const isDocHead = from === plus; // 光标是否在文档头部

    const isLastChild = cursorNodeParent.lastChild === cursorNode;
    const nodePreRow = isDocHead ? null : view.domAtPos(from - plus - 1).node; // 光标前一行节点

    const nodePreRowName = nodePreRow && nodePreRow.nodeName.toUpperCase();

    if (cursorNodeParent.type === blockquote && !nodeBefore && cursorNodeParent.firstChild === cursorNode) {
      unwrapInQuote(state, dispatch);
      return true;
    } // 引用下删除


    if (nodePreRowName === 'BLOCKQUOTE') {
      const newPos = from - 3;

      if (!nodeAfter) {
        tr.delete(from - 1, to + 1);
        tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, newPos));
      } else {
        const cursorNodeSize = cursorNode.nodeSize;

        if (isLastChild) {
          tr.delete(from, from + cursorNodeSize - 1);
        } else {
          tr.delete(from, from + cursorNodeSize);
        }

        if (cursorNode.textContent) {
          tr.insertText(cursorNode.textContent, newPos);
          tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, newPos));
        } else {
          tr.insert(newPos, cursorNode);
          tr.setSelection(prosemirrorState.TextSelection.create(tr.doc, newPos + 1));
        }
      }

      dispatch(tr);
      return true;
    }
  }

  return false;
}
function handleEnter(state, dispatch) {
  const {
    selection,
    schema
  } = state;
  const {
    $cursor
  } = selection;
  if (!$cursor || !isInQuote(state)) return false;
  const link = schema.nodes.link;
  const nodeBefore = $cursor.nodeBefore;
  const nodeAfter = $cursor.nodeAfter; // 引用中链接回车无法取消引用问题

  if ((!nodeBefore || nodeBefore.type === link && nodeBefore.nodeSize === 2) && (!nodeAfter || nodeAfter.type === link && nodeAfter.nodeSize === 2)) {
    return unwrapInQuote(state, dispatch);
  }

  return false;
}

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css = ".ct-blockquote{padding-left:16px;border-left:2px solid #ddd;margin-left:8px;margin-right:0;color:#999}.ct-blockquote h1,.ct-blockquote h2,.ct-blockquote h3,.ct-blockquote h4,.ct-blockquote h5,.ct-blockquote h6,.ct-blockquote p,.ct-blockquote span{color:#999}";
styleInject(css);

class QuoteModule {
  constructor() {
    this.name = 'quote';
    this.schema = schema;
    this.commands = {
      toggle
    };
    this.utils = {
      isInQuote
    };
    this.plugins = [keymap({
      Backspace: handleBackspace,
      'Mod-Backspace': handleBackspace,
      Enter: handleEnter
    })];
  }

}
QuoteModule.moduleName = 'quote';

exports.QuoteModule = QuoteModule;
//# sourceMappingURL=index.js.map



// WEBPACK FOOTER //
// ./~/@mtfe/citadel-editor/lib/quote/index.js